import gql from 'graphql-tag'
import { useContext } from 'react'
import { useQuery } from '../api/graphql'
import { CurrentUserContext } from '../providers/CurrentUserContext'

export const UserOrganizationsQuery = gql`
  query UserOrganizationsQuery {
    currentUser {
      id
      defaultOrganization {
        id
      }
      organizationMemberships {
        id
        role
        organization {
          id
          name
          contactEmail
          phone
          hasActiveSubscription
          owner {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`

export type OrganizationOwner = {
  id: string
  firstName: string | null
  lastName: string | null
}

export type Organization = {
  id: string
  name: string
  contactEmail: string | null
  phone: string | null
  hasActiveSubscription: boolean
  owner: OrganizationOwner
}

export type OrganizationMembership = {
  id: string
  role: string
  organization: Organization
}

type Data = {
  currentUser: {
    id: string
    defaultOrganization: { id: string } | null
    organizationMemberships: OrganizationMembership[]
  }
}

type UseUserOrganizationsReturn = {
  organizations: Organization[]
  defaultOrganizationId: string | null
  loading: boolean
}

const useUserOrganizations = (): UseUserOrganizationsReturn => {
  const { loading: loadingCurrentUser } = useContext(CurrentUserContext)

  const { data, loading } = useQuery<Data>(UserOrganizationsQuery, {
    skip: loadingCurrentUser,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  const organizations =
    data?.currentUser?.organizationMemberships?.map((m) => m.organization) || []
  const defaultOrganizationId = data?.currentUser?.defaultOrganization?.id || null

  return { organizations, defaultOrganizationId, loading: loading || loadingCurrentUser }
}

export default useUserOrganizations
